import { Chalk } from "chalk";

export const chalk = new Chalk({ level: 3 });
